
import React from 'react'
import { useState } from 'react';
import { CheckIconMedium } from '../customicons/CheckIconMedium';
import Stack from '@mui/material/Stack'
import AITestContext from '../../../contexts/AITestContext';
import StatusContext from '../../../contexts/StatusContext';
import { ArrowUpward, ArrowDownward} from "@mui/icons-material"
import { QuestionsOne } from './QuestionsOne';
import {ScrollText} from "../scrolltext/ScrollText"
import { PushButton } from '../pushbutton/PushButton';
import {CustomTooltip} from  '../customtooltip/CustomTooltip'

import './aitest.css'

export const DisplaySubtopics = ({ text, clickHandler }) => {
  const [showquestions, setShowQuestions] = useState(false)

  let {
    selectSubtopic,
    showSubtopicQuestions,
    onNewQuestions,
    createcollegetestmode,
    onChangeSubtopic,
    testnotbought

  } = React.useContext(AITestContext);

  let {
    changeTestLanguage,
  } = React.useContext(StatusContext);


  const handleOnCheck = () => {
    selectSubtopic(text.id)
  }

  const handleShowSubtopics = (index) => {
    setShowQuestions(!showquestions)
    showSubtopicQuestions(index)
  }

  const onClickQuestions = (index) => {
    console.log("onClickNewQuestions")
    selectSubtopic(text.id)
    onNewQuestions(text.id, true)
  }


  return (
    
    <div key={text.id} className="subtopic" onClick={() => { handleOnCheck() }}>
      
      {
        (text.subtopic) &&
        <>
          <div className="subtopics" style = {{ display: "flex",  flexDirection: "column",  alignItems: 'flex-start'}}>
            <Stack direction="row" spacing={2}>
            {
              text.promptsandresponses.length > 0  && 
              <>
              
              {
              showquestions ? 
                <ArrowUpward className="subtopicOpenClose" 
                            style={{marginBottom: '5px', marginRight:'10px'}} 
                            onClick = {()=>{handleShowSubtopics(text.id)}}/>
                :
                <ArrowDownward className="subtopicOpenClose" 
                            style={{marginBottom: '5px', marginRight:'10px'}} 
                            onClick = {()=>{handleShowSubtopics(text.id)}}/>
              }
              </>
            }
           
            {
              createcollegetestmode && text.selected &&
                <CheckIconMedium />
            }

            {
             
               <CustomTooltip title={changeTestLanguage('aitest', 'newquestionstip')}>
                <span>
                <PushButton onClick={()=>onClickQuestions(text.id)} label = {changeTestLanguage('aitest', 'newquestions')} disablebutton={!showquestions || testnotbought}/>             
              </span>
              </CustomTooltip> 
              
            }
          </Stack>
     
          {
            <>
              <br/>
              <ScrollText  rows={2} text={text.subtopic}  onChange={(e) => onChangeSubtopic(text.id, e)}/>
            </>
          }
       
        </div>
        </>
      }

       <div>
            {
              showquestions &&
                <QuestionsOne promptsandresponses={text.promptsandresponses}/>
            }
        </div>

    </div>

  )
}